// import Vue from 'vue'
// import Vuex from 'vuex'

// Vue.use(Vuex)

// export default new Vuex.Store({
//   state: {
//     barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
//     barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
//     drawer: null,
//   },
//   mutations: {
//     SET_BAR_IMAGE (state, payload) {
//       state.barImage = payload
//     },
//     SET_DRAWER (state, payload) {
//       state.drawer = payload
//     },
//   },
//   actions: {

//   },
// })


import Vue from 'vue';
import Vuex from 'vuex';

import aktivasi from './store/module/aktivasi';
import serial from './store/module/serial';
import login from './store/module/login';
import pemasukan from './store/module/pemasukan';
import pengeluaran from './store/module/pengeluaran';
import dashboard from './store/module/dashboard';


Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    aktivasi,
    serial,
    login,
    pemasukan,
    pengeluaran,
    dashboard,
   },
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    drawer: null,
    //tes local
    // API_URL: (process.env.NODE_ENV === 'production') ? 'https://clientq-beta.isn-speed.com/api' : 'http://192.168.0.108/speedq-backend/api',
    // COUNTER_API_URL: (process.env.NODE_ENV === 'production') ? 'https://clientq-beta.isn-speed.com/api/counter/' : 'http://192.168.0.108/speedq-backend/api/counter/',
    //API_URL: (process.env.NODE_ENV === 'production') ? 'https://balisolutionbiz.com/aktivasi/api' : 'https://balisolutionbiz.com/aktivasi/api',
    // ini online beta
    API_URL: (process.env.NODE_ENV === 'production') ? 'https://balisolutionbiz.com/aktivasi/api' :  'https://balisolutionbiz.com/aktivasi/api',
    // COUNTER_API_URL: (process.env.NODE_ENV === 'production') ? 'https://clientq-beta.isn-speed.com/api/counter/' : 'http://192.168.0.108/speedq-backend/api/counter/',
    // ini online asli
    //  API_URL: (process.env.NODE_ENV === 'production') ? 'https://clientq.isn-speed.com/api' : 'http://192.168.0.108/speedq-backend/api',
    //  COUNTER_API_URL: (process.env.NODE_ENV === 'production') ? 'https://clientq.isn-speed.com/api/counter/' : 'http://192.168.0.108/speedq-backend/api/counter/',
    // ini local
    // API_URL: (process.env.NODE_ENV === 'production') ? 'http://192.168.0.108/speedq-backend/api/' : 'http://192.168.0.108/speedq-backend/api/',
    // COUNTER_API_URL: (process.env.NODE_ENV === 'production') ? 'http://192.168.0.108/speedq-backend/api/counter/' : 'http://192.168.0.108/speedq-backend/api/counter/',
    // COUNTER_API_URL: 'https://clientq.isn-speed.com/api/counter/',
     //API_URL: (process.env.NODE_ENV === 'production') ? 'https://clientq-beta.isn-speed.com/api' : 'https://clientq-beta.isn-speed.com/api',
     //COUNTER_API_URL: (process.env.NODE_ENV === 'production') ? 'https://clientq-beta.isn-speed.com/api/counter/' : 'https://clientq-beta.isn-speed.com/api/counter/',
    success_flag: false,
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
      SET_DRAWER (state, payload) {
        state.drawer = payload
      },
  },
  actions: {
  },
});

export default store;

